import { observer } from "mobx-react-lite";

import authStore from "../../stores/auth/authStore";
import loginState from "../../stores/auth/loginState";
import contentStore from "../../stores/cms/contentStore";
import uiStore from "../../stores/uiStore";

import Button from "../Button";
import TranslationText from "../TranslationText";

const LoginButton = () => {
   if (contentStore.isPreviewMode) return null;

   // The login modal cannot open during START_UP, so the button is disabled until startup is done. With an
   // existing session (restored synchronously from storage, or from the query during startup) it shows as
   // loading instead, so returning users do not see "Logg inn" before "Min konto"
   const startingUp = loginState.is("START_UP");
   const resolvingSession = startingUp && authStore.session !== null;

   return (
      <Button
         data-testid="login-button"
         size="regular"
         className="mr-2"
         disabled={startingUp}
         loading={loginState.isLoggingIn() || resolvingSession}
         onClick={uiStore.showLoginModal}
         trackingName="Logg inn navbar"
      >
         <TranslationText textKey="Login.LoginButton" defaultText="Logg inn" />
      </Button>
   );
};

export default observer(LoginButton);
